/* tslint:disable */
/* eslint-disable */
/**
 * SDPS Preprocessing API
 * The pre-processing service manages batches submitted to the SDP.  <br> There are two services available: Contents and Events
 *
 * The version of the OpenAPI document: 0.1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ListedDIP } from './ListedDIP';
import {
    ListedDIPFromJSON,
    ListedDIPFromJSONTyped,
    ListedDIPToJSON,
} from './ListedDIP';

/**
 * 
 * @export
 * @interface ListDipsResponseBody
 */
export interface ListDipsResponseBody {
    /**
     * 
     * @type {Array<ListedDIP>}
     * @memberof ListDipsResponseBody
     */
    items: Array<ListedDIP>;
    /**
     * A cursor for use in the subsequent call.
     * @type {string}
     * @memberof ListDipsResponseBody
     */
    startingAfter?: string;
    /**
     * The total number of items in the collection.
     * @type {number}
     * @memberof ListDipsResponseBody
     */
    totalCount: number;
}

/**
 * Check if a given object implements the ListDipsResponseBody interface.
 */
export function instanceOfListDipsResponseBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "totalCount" in value;

    return isInstance;
}

export function ListDipsResponseBodyFromJSON(json: any): ListDipsResponseBody {
    return ListDipsResponseBodyFromJSONTyped(json, false);
}

export function ListDipsResponseBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListDipsResponseBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ListedDIPFromJSON)),
        'startingAfter': !exists(json, 'starting_after') ? undefined : json['starting_after'],
        'totalCount': json['total_count'],
    };
}

export function ListDipsResponseBodyToJSON(value?: ListDipsResponseBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(ListedDIPToJSON)),
        'starting_after': value.startingAfter,
        'total_count': value.totalCount,
    };
}

